import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import SecurityView from './SecurityView';
import UserSecurityView from './views/UserSecurityView';
import AuditLog from './views/AuditLog';
import GlobalPermissions from './views/GlobalPermissions.vue';
import SystemSettingsView from '@/modules/Security/views/SystemSettingsView.vue';
import LeftNavCustomizationPage from '../LeftNavCustomization/LeftNavCustomizationPage.vue';

const {routes} = router.options;
const route = routes.find(r => r.name === 'app');

const tmpRoutes = [
  {
    path: '/administration', component: SecurityView,
    children: [
      {
        path: 'users',
        component: UserSecurityView,
      },
      {
        path: 'audit-log',
        name: 'auditLogView',
        component: AuditLog,
      },
      {
        path: 'system-settings',
        name: 'systemSettingsView',
        component: SystemSettingsView,
      },
      {
        path: 'global',
        name: 'globalPermissions',
        component: GlobalPermissions,
      },
      {
        path: 'custom-navigation',
        name: 'customNavigation',
        component: LeftNavCustomizationPage,
      },
    ],
  },

];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
// MenuService.addItem(new MenuItem('Security', {
//   text: 'System Info',
//   uuid: 'System Info',
//   permission: 'read',
//   weight: 101,
//   icon: ['fas', 'info-circle'],
//   children: [
//     {
//       path: '/security/users',
//       text: 'User Security',
//       weight: 1,
//       icon: ['fas', 'user-shield']
//     },
//     {
//       path: '/security/audit-log',
//       text: 'Audit Log',
//       weight: 1,
//       icon: ['fas', 'clipboard-list']
//     },
//   ],
// }));
